import { ListItem, Box, Tooltip } from "@mui/material"
import { MarkEmailRead, Task } from "@mui/icons-material"
import { Link, TextField } from "react-admin"
import { InvoiceReadModel, InvoiceReminderReadModel, ReverseInvoiceReadModel } from "../GeneratedClients/FreeBillApi"

const InvoiceCorrelationListItem = ({record, resource}:{record: InvoiceReadModel | ReverseInvoiceReadModel | InvoiceReminderReadModel | any, resource: "invoices" | "invoiceReminders" | "reverseInvoices"}) => {
  return (
    <ListItem>
      {
        <Box display={"flex"}>
          <TextField mr={1} record={record} source="textModel.heading" component={Link} to={`/${resource}/${record.id}/show`} />
          {record.isSendByMail &&
            <Tooltip title="Versendet">
              <MarkEmailRead sx={{ml: 1}} color="primary" fontSize="small" />
            </Tooltip>
          }
          {record.bookingInfos &&
            <Tooltip title="Gebucht">
              <Task sx={{ml: 1}} color="primary" fontSize="small" />
            </Tooltip>
          }
        </Box>
      }
    </ListItem>
  )
}

export default InvoiceCorrelationListItem